import { Button } from "@/shadcnComponents/ui/button";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/shadcnComponents/ui/accordion";
import {
  Command,
  CommandInput,
  CommandList,
  CommandEmpty,
} from "@/shadcnComponents/ui/command";
import mixpanel from "mixpanel-browser";
import { TbArrowRight } from "react-icons/tb";
import {
  InfluencerCard,
  InfluencerCardSkeleton,
} from "../Components/NewCampaignComponents/NewCampaignInfluencerCard";
import { SearchInfluencerItemCard } from "../Components/NewCampaignComponents/NewCampaignSearchInfluencerComponent";
import {
  ArrowLeft,
  ArrowRight,
  ListFilter,
  Loader,
  LoaderIcon,
  Pencil,
  Sparkles,
} from "lucide-react";
import { StackAvatars } from "@/Pages/Influencer/LocationChapters/Components/molecules";
import { useEffect, useState } from "react";

import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/shadcnComponents/ui/navigation-menu";
import { FancyMultiSelect } from "@/shadcnComponents/ui/multiselect";
import { FieldAndPlaceHolderStyles } from "../Helpers/Helper";
import {
  CampaignFormField,
  CampaignInfoTip,
  NoActivePlanAlertButton,
  ToolTipInfo,
} from "../Components/Components";
import {
  SheetTrigger,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
  Sheet,
} from "@/shadcnComponents/ui/sheet";
import { Input } from "@/shadcnComponents/ui/input";
import { cn } from "@/lib/utils";
import { parseStringToNumbers } from "@/Helpers/format-helper";
import { useParams } from "react-router-dom";
import { useBrand } from "@/Providers/Brand";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  CardDescription,
} from "@/shadcnComponents/ui/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shadcnComponents/ui/table";

import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@/shadcnComponents/ui/avatar";
import { Skeleton } from "@/shadcnComponents/ui/skeleton";
import { useNewCampaign } from "../CustomHooks/NewCampaignHooks";
import { useGeneralSettings } from "@/Providers/General";
import { Tabs, TabsList, TabsTrigger } from "@/shadcnComponents/ui/tabs";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/shadcnComponents/ui/select";
import { MultiSelect } from "@/shadcnComponents/ui/multi-select";

export const SelectInfluencerForm = () => {
  const {
    shortlistedInfluencers,
    manualSearch,
    selectedCreators,
    masterData,
    formData,
    searchCreatorInput,
    manuallySearchCreators,
    notSelectedCreators,
    handleSelectCreator,
    handleIgnoreCreator,
    handleSearchCreator,
    handleSelectManualCreator,
    handlePrevious,
    handleSelectChange,
    setIsLoading,
    handleSaveData,
    setRefreshLoading,
    setOpenSelectPopup,
    selectedCities,
    setSelectedCities,
    selectedState,
    setSelectedState,
    selectedCountry,
    setSelectedAudienceLocationIds,

    // filters
    openTryManualFilter,
    setOpenTryManualFilter,
    selectedSuperRoles,
    setSelectedSuperRoles,
    selectedContentCategory,
    selectedAudienceCategory,
    setSelectedAudienceCategory,
    setSelectedContentCategory,
    selectedEngageMentRate,
    setSelectedEngageMentRate,
    selectedUniqueBadge,
    setSelectedUniqueBadge,
    selectedAverageLikes,
    setSelectedAverageLikes,
    selectedYearsOfExperiance,
    setSelectedYearsOfExperiance,
    selectedCompanyTier,
    setSelectedCompanyTier,
    includedCollabCompanyNames,
    setIncludedCollabCompanyNames,
    excludedCollabCompanyNames,
    setExcludedCollabCompanyNames,
    refreshLoading,
  } = useNewCampaign();
  const brandState = useBrand();
  const { collabId } = useParams();
  const generalState = useGeneralSettings();

  const [currentSection, setCurrentSection] = useState<"cards" | "table">(
    "cards"
  );
  const [numberOfAdvanceFiltersApplied, setNumberOfAdvanceFiltersApp] =
    useState(0);
  const [activeTab, setActiveTab] = useState("ai");

  const [tableLoading, setTableLoading] = useState(false);
  const [tableContinueLoading, setTableContinueLoading] = useState(false);
  const [isAdvanceFilterApplied, setAdvanceFiltersApplied] = useState(false);

  const selectedInfluencers = shortlistedInfluencers
    ?.map((item) => (selectedCreators?.includes(item?._id) ? item : undefined))
    ?.filter(Boolean);
  const RemainingShortlistedInfluencers = shortlistedInfluencers
    ?.map((item) => (!selectedCreators?.includes(item?._id) ? item : undefined))
    ?.filter(Boolean);

  const basicFilters = [
    {
      title: "Curr. Role",
      filters: masterData?.AudienceType?.map((item) => ({
        value: item?._id,
        label: item?.LkdAudienceTypeName,
        description: item?.LkdAudienceTypeDesc,
      })),
      placeHolder: "Select the influencers' current role",
      value: selectedSuperRoles,
      setValue: setSelectedSuperRoles,
    },
    {
      title: "Followers",
      placeHolder: "Select Followers",
      isRange: true,
      minValue: parseStringToNumbers(
        formData?.creatorInfo?.minCreatorFollowers
      ),
      setMinValue: (value) =>
        handleSelectChange("minCreatorFollowers", "creatorInfo", value),
      maxValue: parseStringToNumbers(
        formData?.creatorInfo?.maxCreatorFollowers
      ),
      setMaxValue: (value) =>
        handleSelectChange("maxCreatorFollowers", "creatorInfo", value),
    },
    {
      title: "Avg. ER",
      filters: masterData?.AvgEngageMentRate,
      placeHolder: "Select Average Engagement Rate",
      value: selectedEngageMentRate,
      setValue: setSelectedEngageMentRate,
    },
    {
      title: "Niche Cat.",
      filters: masterData?.ContentCategory?.map((item) => ({
        value: item?._id,
        label: item?.categoryName,
        description: item?.categoryDesc,
      })),
      placeHolder: "Select Niche Category",
      value: selectedContentCategory,
      setValue: setSelectedContentCategory,
    },
    {
      title: "Audience",
      filters: masterData?.AudienceType?.map((item) => ({
        value: item?._id,
        label: item?.LkdAudienceTypeName,
        description: item?.LkdAudienceTypeDesc,
      })),
      placeHolder: "Select Audience",
      value: selectedAudienceCategory,
      setValue: setSelectedAudienceCategory,
    },
  ];
  const AdvancedFilters = [
    {
      title: "Badge",
      filters: masterData?.uniqueBadges?.map((badge) => {
        return { label: badge, value: badge };
      }),
      placeHolder: "Select Badge",
      value: selectedUniqueBadge,
      setValue: setSelectedUniqueBadge,
      toolTipInfo: (
        <div>
          Recognition badges the <br /> influencers get on their LinkedIn
          profiles,
          <br /> given by LinkedIn itself
        </div>
      ),
    },
    {
      title: "Average Likes",
      filters: masterData?.AvgLikes,
      placeHolder: "Select Average Likes",
      value: selectedAverageLikes,
      setValue: setSelectedAverageLikes,
    },
    // {
    //   title: "Location",
    //   filters: [
    //     { label: "Location 1", value: "Location 1" },
    //     { label: "Location 2", value: "Location 2" },
    //     { label: "Location 3", value: "Location 3" },
    //     { label: "Location 4", value: "Location 4" },
    //     { label: "Location 5", value: "Location 5" },
    //   ],
    //   placeHolder: "Select Location",
    //   value: formData?.gender,
    //   setValue: (value) => handleSelectChange("gender", value),
    // },
    {
      title: "Years of Experience",
      filters: masterData?.YearsOfExperience,
      placeHolder: "Select Years of Experience",
      value: selectedYearsOfExperiance,
      setValue: setSelectedYearsOfExperiance,
      toolTipInfo: (
        <div>
          This denotes how senior or junior influencers are <br />
          in their professional journeys, in terms of years <br />
          of work experience
        </div>
      ),
    },
    {
      title: "Company Tier",
      filters: masterData?.CompanyTier,
      placeHolder: "Select Company Tier",
      value: selectedCompanyTier,
      setValue: setSelectedCompanyTier,
      toolTipInfo: (
        <div>
          The type of companies that the influencer is associated with, <br />
          from Tier 1 to Tier 5 based on their market position & standing,{" "}
          <br />
          going from highest to lowest
        </div>
      ),
    },
    {
      title: "Collaborated With (included)",
      filters: masterData?.CollabCompanyNames?.filter(
        (item) => !excludedCollabCompanyNames.includes(item.value)
      )?.map((company) => {
        return { label: company.value, value: company.value };
      }),
      placeHolder: "Select company Name",
      value: includedCollabCompanyNames,
      setValue: setIncludedCollabCompanyNames,
      // toolTipInfo: (
      //   <div>
      //     Recognition badges the <br /> influencers get on their LinkedIn
      //     profiles,
      //     <br /> given by LinkedIn itself
      //   </div>
      // ),
    },
    {
      title: "Collaborated With (excluded)",
      filters: masterData?.CollabCompanyNames?.filter(
        (item) => !includedCollabCompanyNames.includes(item.value)
      )?.map((company) => {
        return { label: company.value, value: company.value };
      }),
      placeHolder: "Select company Name",
      value: excludedCollabCompanyNames,
      setValue: setExcludedCollabCompanyNames,
      // toolTipInfo: (
      //   <div>
      //     Recognition badges the <br /> influencers get on their LinkedIn
      //     profiles,
      //     <br /> given by LinkedIn itself
      //   </div>
      // ),
    },
  ];
  const ReviewColumns = [
    { id: "info", name: "Shortlisted Influencers", width: "w-[12%]" },
    { id: "followers", name: "Followers", width: "w-[12%]" },
    { id: "avgER", name: "Avg. ER", width: "w-[12%]" },
    { id: "pastCollabs", name: "Past Collabs", width: "w-[10%]" },

    ...(formData?.campaignInfo?.collabType === "fixed"
      ? [
          {
            id: "recommendedCommercials",
            name: "Recommended Commercials",
            width: "w-[18%]",
          },
          {
            id: "customCommercials",
            name: "Custom Commercials",
            width: "w-full",
          },
        ]
      : []),
  ];

  useEffect(() => {
    handleApplyFilter();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openTryManualFilter]);
  useEffect(() => {
    if (
      (selectedUniqueBadge?.length > 0 ||
        selectedAverageLikes?.length > 0 ||
        selectedYearsOfExperiance?.length > 0 ||
        selectedCompanyTier?.length > 0 ||
        selectedState?.length > 0 ||
        selectedCities?.length > 0) &&
      openTryManualFilter
    ) {
      setAdvanceFiltersApplied(true);
    } else {
      setAdvanceFiltersApplied(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedUniqueBadge,
    selectedAverageLikes,
    selectedYearsOfExperiance,
    selectedCompanyTier,
    openTryManualFilter,
    selectedState,
    selectedCities,
  ]);
  useEffect(() => {
    if (openTryManualFilter) {
      setNumberOfAdvanceFiltersApp(
        (selectedUniqueBadge?.length > 0 ? 1 : 0) +
          (selectedAverageLikes?.length > 0 ? 1 : 0) +
          (selectedYearsOfExperiance?.length > 0 ? 1 : 0) +
          (selectedCompanyTier?.length > 0 ? 1 : 0) +
          (selectedState?.length > 0 ? 1 : 0) +
          (selectedCities?.length > 0 ? 1 : 0)
      );
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedUniqueBadge,
    selectedAverageLikes,
    selectedYearsOfExperiance,
    selectedCompanyTier,
    selectedState,
    selectedCities,
    openTryManualFilter,
  ]);

  const getCityOptions = () => {
    if (selectedState.length === 0 || !masterData?.locationData) return [];

    const options: { value: string; label: string }[] = [];

    selectedState.forEach((stateId) => {
      const state = masterData?.locationData?.states?.find(
        (s) => s.stateId === stateId
      );
      if (state) {
        state.cities
          .filter((item) =>
            ["delhi", "new delhi", "goa"]?.includes(
              item.cityName?.toLowerCase()
            )
              ? true
              : item.cityName !== state?.stateName
          )
          .forEach((city) => {
            options.push({
              value: city.cityId,
              label: city.cityName,
            });
          });
      }
    });

    return options;
  };

  // Update the selection logic in useEffect
  useEffect(() => {
    let newSelectedLocationIds: string[] = [];

    if (!masterData?.locationData) {
      return;
    }

    // If no states selected, include all cities from all states
    if (selectedState.length === 0) {
      if (selectedCountry) {
        masterData?.locationData.states.forEach((state) => {
          state.cities.forEach((city) => {
            newSelectedLocationIds.push(city.cityId);
          });
        });
      }
    }
    // If states selected but no cities, include all cities from selected states
    else if (selectedState.length > 0 && selectedCities.length === 0) {
      selectedState.forEach((stateId) => {
        const state = masterData?.locationData.states.find(
          (s) => s.stateId === stateId
        );
        if (state) {
          state.cities.forEach((city) => {
            newSelectedLocationIds.push(city.cityId);
          });
        }
      });
    }
    // If specific cities are selected, include only those
    else {
      newSelectedLocationIds = selectedCities;
    }

    setSelectedAudienceLocationIds(newSelectedLocationIds);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCountry, selectedState, selectedCities, masterData.locationData]);

  const handleSave = async () => {
    const data = await handleSaveData({
      isAddMore: false,
      isRefresh: true,
    });

    setRefreshLoading(true);
    if (
      formData?.campaignInfo?.collabType === "performance" ||
      (formData?.campaignInfo?.collabType === "fixed" &&
        data?.data?.SelectedInfluencersWithCPI?.every(
          (item) => item?.priceByBrand > 99
        ))
    ) {
      setOpenSelectPopup(true);
    } else {
      generalState.showErrorToast("minimum custom commercial is ₹100");
    }

    setRefreshLoading(false);
  };
  const handleApplyFilter = async () => {
    setRefreshLoading(true);
    await handleSaveData({
      isAddMore: false,
      isRefresh: true,
    });
    setRefreshLoading(false);
    setIsLoading(false);
  };

  return (
    <>
      {currentSection === "cards" && (
        <div className="flex w-full  font-inter flex-col gap-8">
          <Card className="p-4 bg-white border-gray-200">
            <div className="flex items-center justify-between mb-4">
              <div className="space-y-1">
                <h2 className="text-sm font-semibold flex gap-2 items-center">
                  Influencer Selection {openTryManualFilter && "- Manual"}{" "}
                  <CampaignInfoTip
                    content={
                      "There's zero manual coordination needed between you & the influencers you select. Our system will handle it all & notify you at each step."
                    }
                  />
                </h2>
                <p className="text-sm text-gray-500">
                  {shortlistedInfluencers?.length > 0
                    ? `Based on your preferences, the following Influencers are
                          fit for your campaign. Check them out & select the
                          ones you find most suitable`
                    : "Please Fill the form to find the Influencers"}
                </p>
              </div>
              <div className="flex items-center gap-2">
                <Tabs
                  value={activeTab}
                  onValueChange={(value) => {
                    setIsLoading(true);
                    setOpenTryManualFilter((prev) => {
                      return !prev;
                    });
                    setActiveTab(value);
                  }}
                  className="w-[300px]"
                >
                  <TabsList className="grid w-full grid-cols-2">
                    <TabsTrigger
                      value="ai"
                      className="data-[state=active]:bg-gradient-to-r data-[state=active]:from-orange-400 data-[state=active]:via-pink-500 data-[state=active]:to-blue-500 data-[state=active]:text-white"
                    >
                      <Sparkles className="mr-2 h-4 w-4" />
                      AI Mode
                    </TabsTrigger>
                    <TabsTrigger
                      className="items-center flex justify-center px-2 "
                      value="manual"
                    >
                      <Pencil className="mr-2 h-4 w-4" />
                      <span className="mr-1"> Manual Mode </span>
                      <ToolTipInfo
                        size={12}
                        Content={
                          <div className="flex flex-col text-wrap flex-wrap items-start gap-2  ">
                            <span className="text-[#121212] text-base not-italic font-semibold leading-[normal]">
                              Manual Influencer Selection
                            </span>
                            <span className="text-neutral-500  text-xs  not-italic font-normal leading-5">
                              If the AI recommendations don’t meet your needs or
                              you want to explore more options, use manual
                              filters to find influencers. <br />
                              <b>Note:</b> While manually selecting influencers,
                              keep track of your expenses. The AI suggestions
                              were tailored to your budget, but manual selection
                              won’t adjust for it automatically.
                            </span>
                          </div>
                        }
                      />
                    </TabsTrigger>
                  </TabsList>
                </Tabs>
              </div>
            </div>

            {/* filters */}
            {openTryManualFilter && (
              <div className="inline-flex justify-start items-start flex-wrap w-full mt-4 gap-1">
                <NavigationMenu className="justify-start w-full">
                  <NavigationMenuList className="w-full gap-y-2 gap-x-1 flex-1 flex-wrap justify-around items-center ">
                    {/* basic filters */}

                    <div
                      style={{
                        scrollBehavior: "smooth",
                        scrollbarWidth: "thin",
                      }}
                      className="flex max-w-[75%] overflow-x-auto gap-y-2 gap-x-1 p-2 border border-b rounded-sm custom-scrollbar  justify-start items-start "
                    >
                      {basicFilters?.map((item, index) => {
                        return (
                          <NavigationMenuItem key={index}>
                            <NavigationMenuTrigger
                              className={cn(
                                "flex justify-center items-center gap-3 border px-3 py-2 rounded-[5.144px] border-solid border-[#BCBCBC]",
                                item?.value?.length > 0 ||
                                  item?.minValue ||
                                  item?.maxValue
                                  ? "border bg-[rgba(195,38,38,0.12)] rounded-[5.144px] border-solid border-[#E43838]"
                                  : ""
                              )}
                            >
                              {item?.title}{" "}
                              {(item?.value?.length > 0 ||
                                item?.minValue ||
                                item?.maxValue) && (
                                <span className=" w-4 h-4 flex items-center justify-center rounded-full shrink-0 bg-[#E43838] text-[color:var(--Shade-White,#FFF)] text-[7.875px] not-italic font-medium leading-[normal] tracking-[-0.281px]">
                                  {item?.value?.length > 0 ||
                                  item?.minValue ||
                                  item?.maxValue
                                    ? item?.value?.length || 1
                                    : 0}
                                </span>
                              )}
                            </NavigationMenuTrigger>
                            <NavigationMenuContent>
                              <div
                                style={{ scrollbarWidth: "none" }}
                                className="flex w-[400px] max-h-[80vh] m-6 overflow-y-auto flex-col items-start gap-5 rounded-md"
                              >
                                {/* range filters */}
                                {item?.isRange && (
                                  <div className="flex w-full flex-col items-start gap-3 pt-2 pb-3 px-3  rounded border border-slate-100 border-solid">
                                    <span className="text-[color:var(--slate-700,#334155)] text-sm not-italic font-semibold leading-5">
                                      {item?.placeHolder}
                                    </span>
                                    <div className="flex justify-center items-center gap-3 self-stretch pt-5 pb-0 px-[5px]">
                                      <CampaignFormField
                                        labelHead="Minimum"
                                        Children={
                                          <Input
                                            placeholder={item?.placeHolder}
                                            className={
                                              FieldAndPlaceHolderStyles
                                            }
                                            type="number"
                                            value={item?.minValue}
                                            onChange={(e) => {
                                              item?.setMinValue(e.target.value);
                                            }}
                                          />
                                        }
                                        mandatory={true}
                                      />
                                      <CampaignFormField
                                        labelHead="Maximum"
                                        Children={
                                          <Input
                                            placeholder={item?.placeHolder}
                                            className={
                                              FieldAndPlaceHolderStyles
                                            }
                                            type="number"
                                            value={item?.maxValue}
                                            onChange={(e) => {
                                              item?.setMaxValue(e.target.value);
                                            }}
                                          />
                                        }
                                        mandatory={true}
                                      />
                                    </div>
                                  </div>
                                )}

                                {/*select filters  */}
                                {item?.filters && (
                                  <FancyMultiSelect
                                    className={FieldAndPlaceHolderStyles}
                                    FRAMEWORKS={item?.filters}
                                    placeholder={item?.placeHolder}
                                    value={item?.value}
                                    setValue={item?.setValue}
                                    alwaysOpen
                                  />
                                )}
                              </div>
                            </NavigationMenuContent>
                          </NavigationMenuItem>
                        );
                      })}
                    </div>

                    {/* Advanced Filters*/}
                    <Sheet>
                      <SheetTrigger asChild>
                        <div
                          className={cn(
                            `flex justify-center items-center gap-3 px-4 py-2 h-[40px] rounded-[5.144px]  text-xs not-italic font-medium leading-[11.574px] tracking-[-0.322px] cursor-pointer border-2 border-solid border-[#121212]`,
                            isAdvanceFilterApplied
                              ? "border bg-[rgba(195,38,38,0.12)] rounded-[5.144px] border-solid border-[#E43838]"
                              : ""
                          )}
                        >
                          {/* <ListFilter size={16} /> */}
                          <span className="flex items-center gap-2 ">
                            Advanced Filters{" "}
                            {isAdvanceFilterApplied && (
                              <span className=" w-4 h-4 flex items-center justify-center rounded-full shrink-0 bg-[#E43838] text-[color:var(--Shade-White,#FFF)] text-[7.875px] not-italic font-medium leading-[normal] tracking-[-0.281px]">
                                {isAdvanceFilterApplied
                                  ? numberOfAdvanceFiltersApplied
                                  : 0}
                              </span>
                            )}
                          </span>
                        </div>
                      </SheetTrigger>
                      <SheetContent className="w-[400px] overflow-auto ">
                        <SheetHeader>
                          <SheetTitle>Advance Filters</SheetTitle>
                          <SheetDescription></SheetDescription>
                          {AdvancedFilters?.map((item, index) => {
                            return (
                              <CampaignFormField
                                key={`Advance_${index}`}
                                labelHead={item?.title}
                                labelToolTipContent={item?.toolTipInfo}
                                Children={
                                  <FancyMultiSelect
                                    className={FieldAndPlaceHolderStyles}
                                    FRAMEWORKS={item?.filters}
                                    placeholder={item?.placeHolder}
                                    value={item?.value}
                                    setValue={item?.setValue}
                                  />
                                }
                                mandatory={false}
                              />
                            );
                          })}

                          <div className="space-y-6">
                            <CampaignFormField
                              key={`Advance_audience_Country`}
                              labelHead={"Country"}
                              labelToolTipContent={
                                "Select the country of audience you want to reach for this campaign"
                              }
                              Children={
                                <div className="space-y-2">
                                  <Select
                                    disabled
                                    value={selectedCountry || "India"}
                                  >
                                    <SelectTrigger
                                      id="country"
                                      className="w-full"
                                    >
                                      <SelectValue placeholder="Select country" />
                                    </SelectTrigger>
                                    <SelectContent>
                                      <SelectItem value="India">
                                        India
                                      </SelectItem>
                                    </SelectContent>
                                  </Select>
                                  <p className="text-xs text-gray-500">
                                    Currently only supporting India
                                  </p>
                                </div>
                              }
                              mandatory={false}
                            />

                            <CampaignFormField
                              key={`Advance_audience_state`}
                              labelHead={"State/Region"}
                              labelToolTipContent={
                                "Select the state/region of audience you want to reach for this campaign"
                              }
                              Children={
                                <MultiSelect
                                  id="state"
                                  placeholder="All States"
                                  options={masterData?.locationData.states.map(
                                    (state) => ({
                                      value: state.stateId,
                                      label: state.stateName,
                                    })
                                  )}
                                  value={selectedState}
                                  onChange={setSelectedState}
                                  className="w-full"
                                />
                              }
                              mandatory={false}
                            />

                            <CampaignFormField
                              key={`Advance_audience_city`}
                              labelHead={"City"}
                              labelToolTipContent={
                                "Select the city of audience you want to reach for this campaign"
                              }
                              Children={
                                <MultiSelect
                                  id="city"
                                  placeholder="All Cities"
                                  options={getCityOptions()}
                                  value={selectedCities}
                                  onChange={setSelectedCities}
                                  className="w-full"
                                  disabled={selectedState.length === 0}
                                />
                              }
                              mandatory={false}
                            />
                          </div>
                        </SheetHeader>
                      </SheetContent>
                    </Sheet>

                    <Button
                      className="bg-[#f35050] items-end "
                      variant="destructive"
                      onClick={handleApplyFilter}
                    >
                      {refreshLoading ? (
                        <LoaderIcon className="animate-spin " />
                      ) : (
                        <>
                          {/* <span>Apply filters</span> */}
                          <ListFilter size={16} />
                        </>
                      )}
                    </Button>
                  </NavigationMenuList>
                </NavigationMenu>
              </div>
            )}

            {/* selected creators images */}
            {selectedCreators?.length > 0 && (
              <div className="inline-flex w-auto flex-col items-start gap-1.5 px-2.5 py-2 border rounded-[5.144px] mt-4 border-solid border-[#11B814]">
                <div className="text-[#535353] text-xs not-italic font-semibold leading-[normal">
                  {selectedCreators?.length} Selected
                </div>

                <div className="ml-2">
                  <StackAvatars
                    avatarUrls={shortlistedInfluencers
                      ?.map((item) =>
                        selectedCreators?.includes(item?._id) ? item : undefined
                      )
                      ?.filter((item) => item)
                      ?.map((item) => item?.profile)}
                    toolTipInfo={shortlistedInfluencers
                      ?.map((item) =>
                        selectedCreators?.includes(item?._id) ? item : undefined
                      )
                      ?.filter((item) => item)
                      ?.map((item) => item?.name)}
                    variant="default"
                    viewLimit={selectedCreators?.length}
                    avatarClass="border rounded-3xl border-solid border-[#11B814]"
                  />
                </div>
              </div>
            )}

            <div
              style={{
                scrollbarWidth: "thin",
              }}
              className="flex flex-col items-start gap-4 max-h-[80vh] overflow-auto mt-4 "
            >
              {/* selected influencers */}
              {selectedInfluencers?.length > 0 && (
                <div className="flex w-full flex-col gap-4 rounded-[10px] px-2.5 py-2 border border-solid border-[rgba(33,34,34,0.93)] ">
                  <Accordion defaultValue="item-1" type="single" collapsible>
                    <AccordionItem value="item-1">
                      <AccordionTrigger className="flex items-center p-4 gap-2 text-[#121212] text-sm not-italic font-semibold leading-5">
                        Selected Influencers{" "}
                        {`(${selectedInfluencers?.length})`}
                      </AccordionTrigger>
                      <AccordionContent className="mt-4 ">
                        <div className="flex w-full gap-[10px] flex-wrap">
                          {!refreshLoading
                            ? selectedInfluencers?.map((influencer, index) => (
                                <InfluencerCard
                                  onChangePrice={async (
                                    influencerId: string,
                                    price: number
                                  ) =>
                                    await brandState.setPriceForInfluencer({
                                      collabId,
                                      influencerId,
                                      price,
                                    })
                                  }
                                  influencer={influencer}
                                  masterData={masterData}
                                  isSelected={selectedCreators?.includes(
                                    influencer?._id
                                  )}
                                  onClick={async () => {
                                    mixpanel.track(
                                      "Brand Draft Campaign - Select Creator Section: Select Creator Button - clicked"
                                    );
                                    await handleSelectCreator(
                                      influencer,
                                      openTryManualFilter ? "Manual" : "AI"
                                    );
                                  }}
                                  onIgnore={async () => {
                                    mixpanel.track(
                                      "Brand Draft Campaign - Select Creator Section: Ignore Creator Button - clicked"
                                    );
                                    await handleIgnoreCreator(
                                      influencer,
                                      openTryManualFilter ? "Manual" : "AI"
                                    );
                                  }}
                                  index={index}
                                  collabType={
                                    formData?.campaignInfo?.collabType
                                  }
                                />
                              ))
                            : Array(10)
                                ?.fill(1)
                                ?.map((_item, index) => (
                                  <InfluencerCardSkeleton
                                    key={`InfluencerReviewSkeleton_${index}`}
                                  />
                                ))}
                        </div>
                      </AccordionContent>
                    </AccordionItem>
                  </Accordion>
                </div>
              )}

              {/* shortlisted influencers */}
              <div className="flex w-full flex-col gap-4 rounded-[10px] px-2.5 py-2 border border-solid border-[rgba(33,34,34,0.93)] ">
                <Accordion defaultValue="item-1" type="single" collapsible>
                  <AccordionItem value="item-1">
                    <AccordionTrigger className="flex items-center p-4 gap-2 text-[#121212] text-sm not-italic font-semibold leading-5">
                      Suggested Influencers{" "}
                      {`(${RemainingShortlistedInfluencers?.length})`}
                    </AccordionTrigger>
                    <AccordionContent className="mt-4 ">
                      <div className="flex w-full gap-[10px] flex-wrap">
                        {!refreshLoading
                          ? RemainingShortlistedInfluencers?.length > 0 &&
                            RemainingShortlistedInfluencers?.map(
                              (influencer, index) => (
                                <InfluencerCard
                                  onChangePrice={async (
                                    influencerId: string,
                                    price: number
                                  ) =>
                                    await brandState.setPriceForInfluencer({
                                      collabId,
                                      influencerId,
                                      price,
                                    })
                                  }
                                  influencer={influencer}
                                  masterData={masterData}
                                  isSelected={selectedCreators?.includes(
                                    influencer?._id
                                  )}
                                  onClick={async () => {
                                    mixpanel.track(
                                      "Brand Draft Campaign - Select Creator Section: Select Creator Button - clicked"
                                    );
                                    await handleSelectCreator(
                                      influencer,
                                      openTryManualFilter ? "Manual" : "AI"
                                    );
                                  }}
                                  onIgnore={async () => {
                                    mixpanel.track(
                                      "Brand Draft Campaign - Select Creator Section: Ignore Creator Button - clicked"
                                    );
                                    await handleIgnoreCreator(
                                      influencer,
                                      openTryManualFilter ? "Manual" : "AI"
                                    );
                                  }}
                                  index={index}
                                  collabType={
                                    formData?.campaignInfo?.collabType
                                  }
                                />
                              )
                            )
                          : Array(10)
                              ?.fill(1)
                              ?.map((_item, index) => (
                                <InfluencerCardSkeleton
                                  key={`InfluencerReviewSkeleton_${index}`}
                                />
                              ))}
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                </Accordion>
              </div>

              {/* previously suggested influencer */}
              {notSelectedCreators?.filter(
                (item) =>
                  !shortlistedInfluencers?.find(
                    (creator) => creator?._id === item?._id
                  )
              )?.length > 0 && (
                <div className="flex w-full flex-col gap-4 rounded-[10px] px-2.5 py-2 border border-solid border-[rgba(33,34,34,0.93)] ">
                  <Accordion type="single" collapsible>
                    <AccordionItem value="item-2">
                      <AccordionTrigger className="flex items-center p-4 gap-2 text-[#121212] text-sm not-italic font-semibold leading-5">
                        Previously Suggested Influencers{" "}
                        {`(${
                          notSelectedCreators?.filter(
                            (item) =>
                              !shortlistedInfluencers?.find(
                                (creator) => creator?._id === item?._id
                              )
                          )?.length
                        })`}
                      </AccordionTrigger>
                      <AccordionContent className="mt-4 ">
                        <div className="flex w-full gap-[10px] flex-wrap">
                          {notSelectedCreators
                            ?.filter(
                              (item) =>
                                !shortlistedInfluencers?.find(
                                  (creator) => creator?._id === item?._id
                                )
                            )
                            ?.map((influencer, index) => (
                              <InfluencerCard
                                onChangePrice={async (
                                  influencerId: string,
                                  price: number
                                ) =>
                                  await brandState.setPriceForInfluencer({
                                    collabId,
                                    influencerId,
                                    price,
                                  })
                                }
                                influencer={influencer}
                                masterData={masterData}
                                isSelected={selectedCreators?.includes(
                                  influencer?._id
                                )}
                                onClick={async () => {
                                  mixpanel.track(
                                    "Brand Draft Campaign - Select Creator Section: Select Creator Button - clicked"
                                  );
                                  await handleSelectCreator(
                                    influencer,
                                    openTryManualFilter ? "Manual" : "AI"
                                  );
                                }}
                                index={index}
                                collabType={formData?.campaignInfo?.collabType}
                              />
                            ))}
                        </div>
                      </AccordionContent>
                    </AccordionItem>
                  </Accordion>
                </div>
              )}
            </div>

            {/* search bar */}
            <div
              className={cn(
                "flex-col gap-4 w-full",
                manualSearch === "true" ? "flex" : "hidden"
              )}
            >
              <p className="text-[#121212] text-sm not-italic font-semibold leading-5 mt-8 ">
                Search & Add Influencers Manually
              </p>
              <Command className="rounded-lg border shadow-md">
                <CommandInput
                  value={searchCreatorInput}
                  onChangeCapture={(e) => handleSearchCreator(e)}
                  name="creatorSearch"
                  placeholder="search..."
                />
                <CommandList>
                  {searchCreatorInput && !manuallySearchCreators?.length && (
                    <CommandEmpty>No results found.</CommandEmpty>
                  )}
                  {manuallySearchCreators?.length > 0 && (
                    <div className="flex flex-col gap-1">
                      {manuallySearchCreators?.map((item, index) => (
                        <SearchInfluencerItemCard
                          name={item?.name}
                          profile={item?.profile}
                          slug={item?.slug}
                          followers={item?.followers}
                          LinkedInLink={item?.LinkedInLink}
                          isSelected={selectedCreators?.find(
                            (creator) => creator === item?._id
                          )}
                          onClick={async () => {
                            mixpanel.track(
                              "Brand Draft Campaign - Select Creator Section: Selected Button - clicked"
                            );
                            await handleSelectCreator(
                              item,
                              openTryManualFilter ? "Manual" : "AI"
                            );
                            await handleSelectManualCreator(item);
                          }}
                          index={index}
                        />
                      ))}
                    </div>
                  )}
                </CommandList>
              </Command>
            </div>

            <div className="w-full flex justify-end gap-5 mt-[60px] ">
              <Button
                variant="ghost"
                onClick={() => {
                  mixpanel.track(
                    "Brand Draft Campaign - select Influencer Section: Back - clicked"
                  );
                  handlePrevious();
                }}
              >
                Back
              </Button>
              <NoActivePlanAlertButton
                Button={
                  <Button
                    disabled={!selectedCreators?.length}
                    variant="destructive"
                    className="inline-flex h-9 gap-2 items-center justify-center rounded-md  px-4 py-2 text-sm font-medium text-primary-foreground shadow transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50"
                  >
                    {/* Save & Continue <TbArrowRight /> */}
                    Review Selection <TbArrowRight />
                  </Button>
                }
                onClick={async () => {
                  mixpanel.track(
                    "Brand Draft Campaign - select Influencer Section: Save & Continue - clicked"
                  );

                  setCurrentSection("table");
                  setTableLoading(true);
                  await handleApplyFilter(); //to save the price set by brand
                  setTableLoading(false);
                  // handleSave();
                }}
              />
            </div>
          </Card>
        </div>
      )}
      {currentSection === "table" && (
        <div className="flex w-full  font-inter flex-col gap-8">
          {tableLoading ? (
            <span>
              <InfluencerReviewSkeleton />
            </span>
          ) : (
            <div className="flex flex-col w-full justify-between gap-4 items-center">
              <Card className="w-full">
                <CardHeader>
                  <CardTitle className="text-2xl font-bold text-gray-800">
                    Selected Influencers
                  </CardTitle>
                  <CardDescription className="text-gray-600">
                    Review and compare your selected influencers for the
                    campaign. Adjust offer prices if needed.
                  </CardDescription>
                </CardHeader>
                <CardContent className="p-2">
                  <div className="space-y-4 max-h-[calc(100vh-250px)] overflow-y-auto">
                    <Table>
                      <TableHeader>
                        <TableRow>
                          {ReviewColumns.map((column) => (
                            <TableHead
                              className={cn(`${column.width}`)}
                              key={column.id}
                            >
                              <div className="flex gap-2 items-center ">
                                {column.name}
                                {column.id === "avgER" && (
                                  <ToolTipInfo
                                    Content="The percentage of followers engaging with the influencer's content"
                                    size={10}
                                  />
                                )}
                              </div>
                            </TableHead>
                          ))}
                        </TableRow>
                      </TableHeader>
                      <TableBody>
                        {shortlistedInfluencers
                          ?.filter((item) =>
                            selectedCreators?.includes(item?._id)
                          )
                          .map((influencer) => (
                            <TableRow key={influencer._id}>
                              <TableCell className="py-2">
                                <div className="flex items-center space-x-3">
                                  <Avatar className="h-10 w-10">
                                    <AvatarImage
                                      src={influencer.profile}
                                      alt={influencer.name}
                                    />
                                    <AvatarFallback>
                                      {influencer.name.charAt(0)}
                                    </AvatarFallback>
                                  </Avatar>
                                  <div className="text-left">
                                    <div className="font-semibold">
                                      {influencer.name}
                                    </div>
                                    <div className="text-sm text-gray-500 truncate max-w-[200px]">
                                      {influencer.tagline}
                                    </div>
                                  </div>
                                </div>
                              </TableCell>
                              <TableCell className="text-start">
                                {influencer.cleanedFollowers}
                              </TableCell>
                              <TableCell className="text-start">
                                {influencer.LinkedinAnalysis?.avgEngagementPercentage?.toFixed(
                                  2
                                ) || "-"}
                              </TableCell>
                              <TableCell className="text-start">
                                {influencer.collab_count || "-"}
                              </TableCell>
                              {formData?.campaignInfo?.collabType ===
                                "fixed" && (
                                <TableCell className="text-right">
                                  {influencer.recommendedPrice >= 3000
                                    ? `₹${influencer?.recommendedPrice?.toFixed(
                                        2
                                      )}`
                                    : "-"}
                                </TableCell>
                              )}
                              {formData?.campaignInfo?.collabType ===
                                "fixed" && (
                                <TableCell>
                                  {/* <Input
                                    type="number"
                                    value={influencer.priceByBrand}
                                    onChange={async (e) => {
                                      await brandState.setPriceForInfluencer({
                                        collabId,
                                        influencerId: influencer?._id,
                                        price: e.target.value,
                                      });
                                    }}
                                    placeholder="Eg., 4500"
                                    defaultValue={influencer.priceByBrand}
                                    className={`text-[#64748b] w-full ${
                                      influencer?.priceByBrand <= 0 ||
                                      !influencer?.priceByBrand
                                        ? "border-destructive"
                                        : ""
                                    }`}
                                  /> */}
                                  <SelectedInfluencerListPriceInput
                                    influencer={influencer}
                                    brandState={brandState}
                                    collabId={collabId}
                                  />
                                </TableCell>
                              )}
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>
                  </div>
                  <div className="mt-6 flex justify-between">
                    <Button
                      variant="outline"
                      className="flex items-center gap-2"
                      onClick={() => {
                        mixpanel.track(
                          "Brand Draft Campaign - Influencer Table Section: Back - clicked"
                        );
                        setCurrentSection("cards");
                      }}
                    >
                      <ArrowLeft className="h-4 w-4" />
                      Back
                    </Button>
                    <NoActivePlanAlertButton
                      Button={
                        <Button
                          className="flex items-center gap-2"
                          style={{ backgroundColor: "#DC2627" }}
                          disabled={!selectedCreators?.length}
                        >
                          {tableContinueLoading ? (
                            <Loader className="animate-spin" />
                          ) : (
                            "continue"
                          )}
                          <ArrowRight className="h-4 w-4" />
                        </Button>
                      }
                      onClick={async () => {
                        mixpanel.track(
                          "Brand Draft Campaign - Influencer Table Section: continue - clicked"
                        );
                        setTableContinueLoading(true);
                        await handleSave();
                        setTableContinueLoading(false);
                      }}
                    />
                  </div>
                </CardContent>
              </Card>
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default function InfluencerReviewSkeleton() {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-2xl font-bold text-gray-800">
          <Skeleton className="h-8 w-3/4" />
        </CardTitle>
        <CardDescription className="text-gray-600">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-2/3 mt-2" />
        </CardDescription>
      </CardHeader>
      <CardContent className="p-2">
        <div className="space-y-4 max-h-[calc(100vh-250px)] overflow-y-auto">
          <Table>
            <TableHeader>
              <TableRow>
                {Array.from({ length: 6 }).map((_, index) => (
                  <TableHead key={index}>
                    <Skeleton className="h-4 w-full" />
                  </TableHead>
                ))}
              </TableRow>
            </TableHeader>
            <TableBody>
              {Array.from({ length: 5 }).map((_, index) => (
                <TableRow key={index}>
                  <TableCell className="py-2">
                    <div className="flex items-center space-x-3">
                      <Skeleton className="h-10 w-10 rounded-full" />
                      <div className="space-y-2">
                        <Skeleton className="h-4 w-24" />
                        <Skeleton className="h-3 w-32" />
                      </div>
                    </div>
                  </TableCell>
                  <TableCell>
                    <Skeleton className="h-4 w-16 mx-auto" />
                  </TableCell>
                  <TableCell>
                    <Skeleton className="h-4 w-12 mx-auto" />
                  </TableCell>
                  <TableCell>
                    <Skeleton className="h-4 w-12 mx-auto" />
                  </TableCell>
                  <TableCell>
                    <Skeleton className="h-4 w-20 ml-auto" />
                  </TableCell>
                  <TableCell>
                    <Skeleton className="h-8 w-full" />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
        <div className="mt-6 flex justify-between">
          <Button
            variant="outline"
            className="flex items-center gap-2"
            disabled
          >
            <ArrowLeft className="h-4 w-4" />
            Back
          </Button>
          <Button className="flex items-center gap-2" disabled>
            Continue
            <ArrowRight className="h-4 w-4" />
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}

export const SelectedInfluencerListPriceInput = ({
  influencer,
  brandState,
  collabId,
}) => {
  const [price, setPrice] = useState(influencer?.priceByBrand);
  return (
    <>
      <Input
        type="number"
        value={price}
        onChange={async (e) => {
          setPrice(parseInt(e.target.value));
          await brandState.setPriceForInfluencer({
            collabId,
            influencerId: influencer?._id,
            price: e.target.value,
          });
        }}
        placeholder="Eg., 4500"
        className={`text-[#64748b] w-full ${
          price <= 0 || !price ? "border-destructive" : ""
        }`}
      />
    </>
  );
};
